// custom hook imports
import useFetch from "../../../hooks/useFetch";

// components import
import { RxCross1 } from "react-icons/rx";
import DashboardLayout from "../../../components/layouts/DashboardLayout";
import ConfirmationModal from "../../../components/modals/ConfirmationModal/ConfirmationModal";
import InactiveActiveModal from "../../../components/modals/InactiveActiveModal/InactiveActiveModal";
import AddEditPartnersModal from "../../../components/modals/addEditPartners/addEditPartnersModal";
import PageHeading from "../../../components/pageHeading";
import ReactTable from "../../../components/reactTable/ReactTable";
import ThemeButton from "../../../components/theme/ThemeButton";
// react and react-bootstrap imports
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import searchIcon from "../../../assests/svg/searchIcon.svg";
// type and style imports
import { crossIcon, deleteIcon, editIcon } from "../../../assests/Icons/icon";
import { partnersType } from "../../../types/partners";
import styles from "./partners.module.scss";

// yup , toastify and formik imports
import { useFormik } from "formik";
import moment from "moment";
import { CiExport, CiImport, CiMail } from "react-icons/ci";
import * as yup from "yup";
import { notifyBugsnagError, removeDashed, showToast } from "../../../common/utils/Functions";
import ReactExcel from "../../../components/reactExcel/ReactExcel";
import { referredBySelectType } from "../../../types/organization";

const ALLOWED_UPLOAD_EXTENSIONS = [".csv", ".xlsx", ".xls"];

const EVERWASH_PARTNER_ID = Number(process.env.REACT_APP_EVERWASH_PARTNER_ID);

const isEverwashPartner = (partner?: partnersType | null) =>
  Number(partner?.id) === EVERWASH_PARTNER_ID;

const Partners = () => {
  /**
   * @State to store searched value
   */
  const [searchValue, setSearchValue] = useState("");
  const [excelData, setExcelData] = useState<any>([]);

  /**
   * @Action states to open @Active @Delete @Add_Edit Modals
   */
  const [showActive, setShowActive] = useState(false); //  It's use to open "In-active/Active" modal
  const [showDelete, setShowDelete] = useState(false); //  It's use to open "Delete" modal
  const [show, setShow] = useState(false); //  It's use to open "Add/Edit" modal
  const [editModal, setEditModal] = useState(false); //  It's use to change edit-form condition

  /**
   * @functions  to handle above ⬆️  @action states
   * 1. toggleActive   :- Used to handle "In-active/Active" modal
   * 2. toggleDelete   :- Used to handle "Delete" modal
   * 3. toggleAddEdit  :- Used to handle "Add/Edit" modal
   */
  const toggleActive = () => setShowActive(!showActive);
  const toggleDelete = () => setShowDelete(!showDelete);
  const toggleAddEdit = () => setShow(!show);

  /**
   * @Data_list states  these below states are used to store data which will render in React-table
   * 1. partnerList  :- Array of partners data list
   * 2. selectedItem :- Object of selceted partner data
   */
  const [partnerList, setParnterList] = useState<partnersType[]>();
  const [selectedItem, setSelectedItem] = useState<partnersType>();
  const [selectedItemID, setSelectedItemID] = useState<any>('');
  const orgUploadInputRef = useRef<HTMLInputElement>(null);
  const propertyUploadInputRef = useRef<HTMLInputElement>(null);
  const uploadPartnerRef = useRef<partnersType | null>(null);

  /**
   * @Pagination states
   * 1. pageLimit    :- store limit of data that will render on current page
   * 2. totalRecords :- store total number of data in partners api
   * 3. currentPage  :- store current page number
   */
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);

  /**
   * @Api_Definition variables
   * 1. listApi        :- Constant to handle list all partners data;
   * 2. addPartnerApi  :- Constant to handle Add partner
   * 3. editPartnerApi :- Constant to handle Edit partner
   * 4. statusApi      :- Constant to handle status of partner
   * 5. deleteApi      :- Constant to handle delete partner
   */


  const [referrerList, setReferrerList] = useState<referredBySelectType[]>();
  const [referrerEditModal, setReferrerEditModal] = useState(false);
  const [referrerExcelData, setReferrerExcelData] = useState<any>([]);
  const [referrerSearchValue, setReferrerSearchValue] = useState("");
  const [referrerPageLimit, setReferrerPageLimit] = useState<number>(10);
  const [referrerTotalRecords, setReferrerTotalRecords] = useState<number>(0);
  const [referrerCurrentPage, setReferrerCurrentPage] = useState<number>(1);
  const [referrerShow, setReferrerShow] = useState(false);
  const [referrerDelete, setReferrerDelete] = useState(false);
  const [referrerActive, setReferrerActive] = useState(false); //  It's use to open "In-active/Active" modal
  const [selectedReferrerItem, setSelectedReferrerItem] = useState<any>();
  const [selectedReferrerItemID, setSelectedReferrerItemID] = useState<any>('');

  const toggleReferrerAddEdit = () => setReferrerShow(!referrerShow);
  const toggleReferrerDelete = () => setReferrerDelete(!referrerDelete);
  const toggleReferrerActive = () => setReferrerActive(!referrerActive);




  /** ------- 1. @listApi ------ */
  const [
    listApi,
    { response: listResponse, error: listError, loading: partnerListLoading },
  ] = useFetch("/partners/list", {
    method: "post",
  });



  /** Api definition */
  const [
    getExcelData,
    {
      response: excelDataResponse,
      error: excelDataError,
      loading: excelDataLoading,
    },
  ] = useFetch(`/v1/partners/properties-list/${selectedItemID}`, {
    method: "POST",
  });

  /** -------2. @addPartnerApi ------ */
  const [
    addPartnerApi,
    {
      response: addPartnerResponse,
      loading: addPartnerLoading,
      error: addPartnerError,
    },
  ] = useFetch("/partners/add", {
    method: "post",
  });

  /** -------3. @editPartnerApi ------ */
  const [
    editPartnerApi,
    {
      response: editPartnerResponse,
      loading: editPartnerLoading,
      error: editPartnerError,
    },
  ] = useFetch(`/partners/update/${selectedItem?.uuid}`, {
    method: "put",
  });

  /** -------4. @statusApi ------ */
  const [
    statusApi,
    { response: statusResponse, loading: statusLoading, error: statusError },
  ] = useFetch(`/partners/active-inactive/${selectedItem?.uuid}`, {
    method: "post",
  });

  /** -------5. @deleteApi ------ */
  const [
    deleteApi,
    { response: deleteResponse, loading: deleteLoading, error: deleteError },
  ] = useFetch(`/partners/delete/${selectedItem?.uuid}`, {
    method: "delete",
  });

  /** -------6. @sendPartnerNewAccountEmailApi ------ */
  const [
    sendPartnerNewAccountEmailApi,
    {
      response: sendPartnerNewAccountEmailResponse,
      error: sendPartnerNewAccountEmailError,
    },
  ] = useFetch("/partners", {
    method: "post",
  });

  /** -------7. @bulkImportApi ------ */
  const [
    bulkImportApi,
    {
      response: bulkImportResponse,
      loading: bulkImportLoading,
      error: bulkImportError,
    },
  ] = useFetch(
    "/organization/bulk-import",
    {
      method: "post",
    },
    "formdata"
  );

  /** -------8. @propertyBulkImportApi ------ */
  const [
    propertyBulkImportApi,
    {
      response: propertyBulkImportResponse,
      loading: propertyBulkImportLoading,
      error: propertyBulkImportError,
    },
  ] = useFetch(
    "/property/bulk-import",
    {
      method: "post",
    },
    "formdata"
  );


  /**
   * @Call_apis by Use-Effect hook
   */


  /**
   * @Call all partner data using @listApi constant
   */
  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        listApi({
          start: (currentPage - 1) * pageLimit,
          limit: pageLimit,
          search: searchValue,
        });
      } catch (e: any) {
        notifyBugsnagError(e, { api: "listApi" });
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchValue, currentPage, pageLimit]);

  /**
   * @handle_Response of above api call using @listApi constant
   * => in this effect
   * 1. @setTotalRecords setState updates with total records
   * 2. @setParnterList  setState updates with incoming partner-data
   * 3. @if_statement    to handle error if api not responded
   */
  useEffect(() => {
    if (listResponse) {
      setTotalRecords(listResponse.data?.totalRecords);
      const updatedList = listResponse.data.list.map((item: any) => ({
        id: item.id,
        name: item.name,
        org_count: item.org_count,
        property_count: item?.property_count,
        allow_third_party_integration: item?.allow_third_party_integration,
        no_of_services: item.services_count,
        is_active: item.is_active,
        uuid: item.uuid,
      }));
      setParnterList(updatedList);
    }
    if (listError) {
      showToast(listError.message as string, "error");
    }
  }, [listResponse, listError]);


  /**
   * @handle_AddApi_Response of form-submition api call using @addPartnerApi constant
   * => in this effect
   * 1. @if_statement  that it responded ok then show toast success message
   * 2. @toggleAddEdit this handler use to close Add/Edit Modal
   * 3. @if_statement  to handle error if api not responded
   */
  useEffect(() => {
    if (addPartnerResponse) {
      showToast(addPartnerResponse.message as string, "success");
      try {
        listApi({
          start: 0,
          limit: 10,
          search: searchValue,
        });
      } catch (e: any) {
        notifyBugsnagError(e, { api: "listApi" });
      }
      setCurrentPage(1);
      formik.resetForm();
      toggleAddEdit();
    }
    if (addPartnerError) {
      showToast(addPartnerError.message as string, "error");
    }
  }, [addPartnerResponse, addPartnerError]);

  /**
   * @handle_DeleteApi_Response on delete partner api call using @deleteApi constant
   * => in this effect
   * 1. @if_statement   that it responded ok then show toast success message
   * 2. @toggleDelete   this handler use to close Delete Modal
   * 3. @setParnterList update partner object that matched with deleted item id
   * 4. @if_statement   to handle error if api not responded
   */
  useEffect(() => {
    if (deleteResponse) {
      showToast(deleteResponse.message as string, "success");
      toggleDelete();
      try {
        listApi({
          start: (currentPage - 1) * pageLimit,
          limit: pageLimit,
          search: searchValue,
        });
      } catch (e: any) {
        notifyBugsnagError(e, { api: "listApi" });
      }
    }
    if (deleteError) {
      showToast(deleteError.message as string, "error");
    }
  }, [deleteResponse, deleteError]);

  useEffect(() => {
    if (sendPartnerNewAccountEmailResponse) {
      showToast(sendPartnerNewAccountEmailResponse.message as string, "success");
    }
    if (sendPartnerNewAccountEmailError) {
      showToast(sendPartnerNewAccountEmailError.message as string, "error");
    }
  }, [sendPartnerNewAccountEmailResponse, sendPartnerNewAccountEmailError]);

  /**
   * @handle_EditApi_Response on form-submition partner api call using @editPartnerApi constant
   * => in this effect
   * 1. @if_statement   that it responded ok then show toast success message
   * 2. @toggleAddEdit  this handler use to close Add/Edit Modal
   * 3. @setParnterList update partner object that matched with edited item id
   * 4. @if_statement   to handle error if api not responded
   */
  useEffect(() => {
    if (editPartnerResponse) {
      showToast(editPartnerResponse.message as string, "success");
      toggleAddEdit();
      const updatedList = partnerList?.map((item: partnersType) =>
        selectedItem?.id === item.id
          ? {
            ...item,
            name: editPartnerResponse.data?.name,
            allow_third_party_integration:
              editPartnerResponse?.data?.allow_third_party_integration,
          }
          : item
      );
      setParnterList(updatedList);
    }
    if (editPartnerError) {
      showToast(editPartnerError.message as string, "error");
    }
  }, [editPartnerResponse, editPartnerError]);

  /**
   * @handle_StatusApi_Response on change active status of partner api call using @statusApi constant
   * => in this effect
   * 1. @if_statement   that it responded ok then show toast success message
   * 2. @toggleActive   this handler use to close Ative/Inactive Modal
   * 3. @setParnterList update partner object that matched with changed status item id
   * 4. @if_statement  to handle error if api not responded
   */
  useEffect(() => {
    if (statusResponse) {
      showToast(statusResponse.message as string, "success");
      toggleActive();
      const updatedList = partnerList?.map((item: partnersType) =>
        selectedItem?.id === item.id
          ? { ...item, is_active: item.is_active ? 0 : 1 }
          : item
      );
      setParnterList(updatedList);
    }
    if (statusError) {
      showToast(statusError.message as string, "error");
    }
  }, [statusResponse, statusError]);

  /**
   * @handle_BulkImportApi_Response for organization CSV/Excel upload
   */
  useEffect(() => {
    if (bulkImportResponse) {
      showToast(bulkImportResponse.message as string, "success");
      try {
        listApi({
          start: (currentPage - 1) * pageLimit,
          limit: pageLimit,
          search: searchValue,
        });
      } catch (e: any) {
        notifyBugsnagError(e, { api: "listApi" });
      }
      uploadPartnerRef.current = null;
    }
    if (bulkImportError) {
      showToast(bulkImportError.message as string, "error");
    }
  }, [bulkImportResponse, bulkImportError]);

  /**
   * @handle_PropertyBulkImportApi_Response for property CSV/Excel upload
   */
  useEffect(() => {
    if (propertyBulkImportResponse) {
      showToast(propertyBulkImportResponse.message as string, "success");
      try {
        listApi({
          start: (currentPage - 1) * pageLimit,
          limit: pageLimit,
          search: searchValue,
        });
      } catch (e: any) {
        notifyBugsnagError(e, { api: "listApi" });
      }
      uploadPartnerRef.current = null;
    }
    if (propertyBulkImportError) {
      showToast(propertyBulkImportError.message as string, "error");
    }
  }, [propertyBulkImportResponse, propertyBulkImportError]);

  const handleOrganizationFileChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files?.[0];
    e.target.value = "";

    if (!file) return;

    const extension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();

    if (!ALLOWED_UPLOAD_EXTENSIONS.includes(extension)) {
      showToast(
        "Please select a CSV or Excel file (.csv, .xlsx, .xls).",
        "error"
      );
      return;
    }

    const partner = uploadPartnerRef.current;
    if (!partner?.id) {
      showToast("Unable to identify the selected partner.", "error");
      return;
    }

    if (!isEverwashPartner(partner)) {
      showToast(
        "Organization upload is only available for the Everwash partner.",
        "error"
      );
      return;
    }

    try {
      const formdata = new FormData();
      formdata.append("file", file);
      formdata.append("partner_id", String(partner.id));
      bulkImportApi(formdata);
    } catch (err: any) {
      notifyBugsnagError(err, { api: "bulkImportApi" });
    }
  };

  const handlePropertyFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = "";

    if (!file) return;

    const extension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();

    if (!ALLOWED_UPLOAD_EXTENSIONS.includes(extension)) {
      showToast(
        "Please select a CSV or Excel file (.csv, .xlsx, .xls).",
        "error"
      );
      return;
    }

    const partner = uploadPartnerRef.current;
    if (!partner?.id) {
      showToast("Unable to identify the selected partner.", "error");
      return;
    }

    if (!isEverwashPartner(partner)) {
      showToast(
        "Property upload is only available for the Everwash partner.",
        "error"
      );
      return;
    }

    try {
      const formdata = new FormData();
      formdata.append("file", file);
      formdata.append("partner_id", String(partner.id));
      propertyBulkImportApi(formdata);
    } catch (err: any) {
      notifyBugsnagError(err, { api: "propertyBulkImportApi" });
    }
  };

  /**
   * @constant to store formik initial values
   */
  const initialValues = {
    name: "",
    allow_third_party_integration: 0,
  };

  /**
   * @constant to initialise useFormik hook
   */
  const formik = useFormik({
    initialValues,
    validationSchema: yup.object().shape({
      name: yup
        .string()
        .max(50, "Partner name must be less than 50 characters.")
        .trim()
        .required("Please enter partner name."),
      allow_third_party_integration: yup.number().notRequired(),
    }),
    onSubmit: (values: partnersType) => {
      // Handle form submission here
      try {
        editModal ? editPartnerApi(values) : addPartnerApi(values);
      } catch (e: any) {
        notifyBugsnagError(e, { api: "editPartnerApi || addPartnerApi" });
      }
    },
  });

  // New formik instance for referrers
  const referrerFormik = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema: yup.object().shape({
      name: yup
        .string()
        .max(50, "Referrer name must be less than 50 characters.")
        .trim()
        .required("Please enter referrer name."),
    }),
    onSubmit: (values: any) => {
      try {
        referrerEditModal ? editReferrerApi(values) : addReferrerApi(values);
      } catch (e: any) {
        notifyBugsnagError(e, { api: "addReferrerApi || editReferrerApi" });
      }
    },
  });

  const excelHeaders =
    [
      { key: "org_name", header: "Organization Name	", width: 40 },
      { key: "org_admin_name", header: "Organization Admin Name", width: 40 },
      { key: "org_admin_email", header: "Organization Admin Email", width: 40 },
      { key: "org_copy_link", header: "Organization Tipping Url", width: 40 },
      { key: "prop_name", header: "Property Name", width: 40 },
      { key: "prop_address", header: "Property Address", width: 100 },
      { key: "prop_city", header: "Property City", width: 40 },
      { key: "prop_state", header: "Property State", width: 40 },
      { key: "prop_zipcode", header: "Property Zipcode", width: 40 },
      { key: "prop_copyLink", header: "Property Tipping Url", width: 40 },
      { key: "createdAt", header: "Property Created At", width: 40 },
      { key: "org_everwash_id", header: "Organization Everwash ID", width: 40 },
      { key: "prop_everwash_id", header: "Property Everwash ID", width: 40 },
    ]

  useEffect(() => {
    if (excelDataResponse?.data?.length > 0) {
      const updateOrgExcel = excelDataResponse.data?.map((item: any) => {
        // If properties_details is empty, create one row with org data
        if (!item?.properties_details?.length) {
          return [{
            org_name: item?.name ?? removeDashed,
            org_admin_name: item?.user_details?.OrgAdminName ?? removeDashed,
            org_admin_email: item?.user_details?.email ?? removeDashed,
            org_copy_link: item?.copy_link ?? removeDashed,
            prop_name: removeDashed,
            prop_address: removeDashed,
            prop_city: removeDashed,
            prop_state: removeDashed,
            prop_zipcode: removeDashed,
            prop_copyLink: removeDashed,
            createdAt: removeDashed,
            org_everwash_id: item?.partner_reference_id ?? removeDashed,
            prop_everwash_id: removeDashed,
          }];
        }

        // Map each property detail to its own row
        return item?.properties_details?.map((property: any) => ({
          org_name: item?.name ?? removeDashed,
          org_admin_name: item?.user_details?.OrgAdminName ?? removeDashed,
          org_admin_email: item?.user_details?.email ?? removeDashed,
          org_copy_link: item?.copy_link ?? removeDashed,
          prop_name: property?.name ?? removeDashed,
          prop_address: property?.address ?? removeDashed,
          prop_city: property?.city ?? removeDashed,
          prop_state: property?.property_state_details?.name ?? removeDashed,
          prop_zipcode: property?.zip_code ?? removeDashed,
          prop_copyLink: property?.copy_link ?? removeDashed,
          createdAt: property?.createdAt ? moment(property?.createdAt).format("MM/DD/YYYY") : removeDashed,
          org_everwash_id: item?.partner_reference_id ?? removeDashed,
          prop_everwash_id: property?.partner_reference_id ?? removeDashed,
        }));
      }).flat();

      setExcelData(updateOrgExcel || []);
    }

    if (excelDataError) {
      showToast(excelDataError.message as string, "error");
    }
  }, [excelDataResponse, excelDataError]);


  /**
   * @Array :- for table headings that passed as a prop to React-Table component
   */
  const tableHeadings = [{ key: "name", label: "Name" }, { key: "org_count", label: "Total Organizations" }, { key: "property_count", label: "Total Properties" }];

  /**
   * @Array :- for action button dropdown values and passes to React table component
   */
  const actionButtonOptions = [
    {
      name: "Edit",
      icon: editIcon,
      onClick: (item: partnersType) => {
        formik.resetForm();
        toggleAddEdit();
        formik.resetForm();
        setEditModal(true);
        setSelectedItem(item);
        formik.setFieldValue("name", item.name);
        formik.setFieldValue(
          "allow_third_party_integration",
          item.allow_third_party_integration
        );
      },
    },
    {
      name: "Inactive",
      icon: crossIcon,
      onClick: (item: partnersType) => {
        toggleActive();
        setSelectedItem(item);
      },
    },
    {
      name: "Delete",
      icon: deleteIcon,
      onClick: (item: partnersType) => {
        toggleDelete();
        setSelectedItem(item);
      },
    },
    {
      name: "Download Properties",
      icon: <CiExport />,
      onClick: (item: any) => {
        setSelectedItem(item);
        setSelectedItemID(item?.uuid);
      },
    },
    {
      name: "Upload New Properties",
      icon: <CiImport />,
      onClick: (item: partnersType) => {
        uploadPartnerRef.current = item;
        setSelectedItem(item);
        propertyUploadInputRef.current?.click();
      },
      condition: (item: partnersType) => isEverwashPartner(item),
    },
    {
      name: "Upload New Organizations",
      icon: <CiImport />,
      onClick: (item: partnersType) => {
        uploadPartnerRef.current = item;
        setSelectedItem(item);
        orgUploadInputRef.current?.click();
      },
      condition: (item: partnersType) => isEverwashPartner(item),
    },
    {
      name: "Send Partner New Account Email",
      icon: <CiMail />,
      onClick: async (item: partnersType) => {
        if (!item.uuid) {
          showToast("Partner UUID is required to send a new account email.", "error");
          return;
        }

        try {
          await sendPartnerNewAccountEmailApi(undefined, {
            url: `/partners/${item.uuid}/send-new-account-email`,
          });
        } catch (e: any) {
          notifyBugsnagError(e, { api: "sendPartnerNewAccountEmailApi" });
        }
      },
      condition: (item: partnersType) => isEverwashPartner(item),
    },
  ];

  useEffect(() => {
    if (selectedItemID) {
      getExcelData();
    }
  }, [selectedItemID]);


  {/** Referrer section starts */ }

  /** ------- 1. @referrerListApi ------ */
  const [
    referrerListApi,
    { response: referrerListResponse, error: referrerListError, loading: referrerListLoading },
  ] = useFetch("/referrers/list", {
    method: "post",
  });

  /** -------2. @addReferrerApi ------ */
  const [
    addReferrerApi,
    {
      response: addReferrerResponse,
      loading: addReferrerLoading,
      error: addReferrerError,
    },
  ] = useFetch("/referrers/add", {
    method: "post",
  });

  /** -------3. @editReferrerApi ------ */
  const [
    editReferrerApi,
    {
      response: editReferrerResponse,
      loading: editReferrerLoading,
      error: editReferrerError,
    },
  ] = useFetch(`/referrers/update/${selectedReferrerItem?.uuid}`, {
    method: "put",
  });

  /** -------4. @deleteReferrerApi ------ */
  const [
    deleteReferrerApi,
    { response: deleteReferrerResponse, loading: deleteReferrerLoading, error: deleteReferrerError },
  ] = useFetch(`/referrers/delete/${selectedReferrerItem?.uuid}`, {
    method: "delete",
  });


  /** -------5. @referrerStatusApi ------ */
  const [
    referrerStatusApi,
    { response: referrerStatusResponse, loading: referrerStatusLoading, error: referrerStatusError },
  ] = useFetch(`/referrers/active-inactive/${selectedReferrerItem?.uuid}`, {
    method: "post",
  });

  const [
    getReferrerExcelData,
    {
      response: referrerExcelDataResponse,
      error: referrerExcelDataError,
      loading: referrerExcelDataLoading,
    },
  ] = useFetch(`/referrers/properties-list/${selectedReferrerItemID}`, {
    method: "POST",
  });

  /**
 * @Call all referrer data using @referrerListApi constant
 */
  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        referrerListApi({
          start: (referrerCurrentPage - 1) * referrerPageLimit,
          limit: referrerPageLimit,
          search: referrerSearchValue,
        });
      } catch (e: any) {
        notifyBugsnagError(e, { api: "referrerListApi" });
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [referrerSearchValue, referrerCurrentPage, referrerPageLimit]);


  useEffect(() => {
    if (referrerListResponse) {
      setReferrerTotalRecords(referrerListResponse.data?.totalRecords);
      const updatedList = referrerListResponse.data.list.map((item: any) => ({
        id: item.id,
        name: item.name,
        org_count: item.org_count,
        property_count: item?.property_count,
        is_active: item.is_active,
        uuid: item.uuid,
      }));
      setReferrerList(updatedList);
    }
    if (referrerListError) {
      showToast(referrerListError.message as string, "error");
    }
  }, [referrerListResponse, referrerListError]);


  useEffect(() => {
    if (addReferrerResponse) {
      showToast(addReferrerResponse.message as string, "success");
      try {
        referrerListApi({
          start: 0,
          limit: 10,
          search: referrerSearchValue,
        });
      } catch (e: any) {
        notifyBugsnagError(e, { api: "referrerListApi" });
      }
      setReferrerCurrentPage(1);
      referrerFormik.resetForm();
      toggleReferrerAddEdit();
    }
    if (addReferrerError) {
      showToast(addReferrerError.message as string, "error");
    }
  }, [addReferrerResponse, addReferrerError]);


  useEffect(() => {
    if (editReferrerResponse) {
      showToast(editReferrerResponse.message as string, "success");
      toggleReferrerAddEdit();
      const updatedList = referrerList?.map((item: any) =>
        selectedReferrerItem?.id === item.id
          ? {
            ...item,
            name: editReferrerResponse.data?.name,
          }
          : item
      );
      setReferrerList(updatedList);
    }
    if (editReferrerError) {
      showToast(editReferrerError.message as string, "error");
    }
  }, [editReferrerResponse, editReferrerError]);


  useEffect(() => {
    if (deleteReferrerResponse) {
      showToast(deleteReferrerResponse.message as string, "success");
      toggleReferrerDelete();
      try {
        referrerListApi({
          start: (referrerCurrentPage - 1) * referrerPageLimit,
          limit: referrerPageLimit,
          search: referrerSearchValue,
        });
      } catch (e: any) {
        notifyBugsnagError(e, { api: "referrerListApi" });
      }
    }
    if (deleteReferrerError) {
      showToast(deleteReferrerError.message as string, "error");
    }
  }, [deleteReferrerResponse, deleteReferrerError]);


  useEffect(() => {
    if (referrerStatusResponse) {
      showToast(referrerStatusResponse.message as string, "success");
      toggleReferrerActive();
      const updatedList = referrerList?.map((item: any) =>
        selectedReferrerItem?.id === item.id
          ? { ...item, is_active: item.is_active ? 0 : 1 }
          : item
      );
      setReferrerList(updatedList);
    }
    if (referrerStatusError) {
      showToast(referrerStatusError.message as string, "error");
    }
  }, [referrerStatusResponse, referrerStatusError]);



  useEffect(() => {
    if (referrerExcelDataResponse?.data?.length > 0) {
      const updateOrgExcel = referrerExcelDataResponse.data?.map((item: any) => {
        // If properties_details is empty, create one row with org data
        if (!item?.properties_details?.length) {
          return [{
            org_name: item?.name ?? removeDashed,
            org_admin_name: item?.user_details?.OrgAdminName ?? removeDashed,
            org_admin_email: item?.user_details?.email ?? removeDashed,
            org_copy_link: item?.copy_link ?? removeDashed,
            prop_name: removeDashed,
            prop_address: removeDashed,
            prop_city: removeDashed,
            prop_state: removeDashed,
            prop_zipcode: removeDashed,
            prop_copyLink: removeDashed,
            createdAt: removeDashed,
            org_everwash_id: item?.partner_reference_id ?? removeDashed,
            prop_everwash_id: removeDashed,
          }];
        }

        // Map each property detail to its own row
        return item?.properties_details?.map((property: any) => ({
          org_name: item?.name ?? removeDashed,
          org_admin_name: item?.user_details?.OrgAdminName ?? removeDashed,
          org_admin_email: item?.user_details?.email ?? removeDashed,
          org_copy_link: item?.copy_link ?? removeDashed,
          prop_name: property?.name ?? removeDashed,
          prop_address: property?.address ?? removeDashed,
          prop_city: property?.city ?? removeDashed,
          prop_state: property?.property_state_details?.name ?? removeDashed,
          prop_zipcode: property?.zip_code ?? removeDashed,
          prop_copyLink: property?.copy_link ?? removeDashed,
          createdAt: property?.createdAt ? moment(property?.createdAt).format("MM/DD/YYYY") : removeDashed,
          org_everwash_id: item?.partner_reference_id ?? removeDashed,
          prop_everwash_id: property?.partner_reference_id ?? removeDashed,
        }));
      }).flat();

      setReferrerExcelData(updateOrgExcel || []);
    }

    if (referrerExcelDataError) {
      showToast(referrerExcelDataError.message as string, "error");
    }
  }, [referrerExcelDataResponse, referrerExcelDataError]);


  /**
 * @Array :- for referrer action button dropdown values and passes to React table component
 */
  const referrerActionButtonOptions = [
    {
      name: "Edit",
      icon: editIcon,
      onClick: (item: any) => {
        referrerFormik.resetForm();
        toggleReferrerAddEdit();
        referrerFormik.resetForm();
        setReferrerEditModal(true);
        setSelectedReferrerItem(item);
        referrerFormik.setFieldValue("name", item.name);
      },
    },

    {
      name: "Inactive",
      icon: crossIcon,
      onClick: (item: any) => {
        toggleReferrerActive();
        setSelectedReferrerItem(item);
      },
    },
    {
      name: "Delete",
      icon: deleteIcon,
      onClick: (item: any) => {
        toggleReferrerDelete();
        setSelectedReferrerItem(item);
      },
    },
    {
      name: "Download Properties",
      icon: <CiExport />,
      onClick: (item: any) => {

        setSelectedReferrerItem(item);
        setSelectedReferrerItemID(item?.uuid);
      },
    }
  ];

  useEffect(() => {
    if (selectedReferrerItemID) {
      getReferrerExcelData();
    }
  }, [selectedReferrerItemID]);

  return (
    <DashboardLayout>
      <Container className="h-100">
        <div className={styles.dash_page}>
          <PageHeading
            heading="Partners"
            subHeading="Here is the information about all your partners."
          >
            <div className={styles.search}>
              <div className={styles.searchField}>
                <img
                  src={searchIcon}
                  className={styles.searchIcon}
                  alt="search icon"
                />

                <input
                  type="text"
                  placeholder="Search by Partner"
                  className="me-3"
                  value={searchValue}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setSearchValue(e.target.value);
                  }}
                  autoComplete="off"
                />
                {searchValue ? (
                  <span
                    className={styles.crossIcon}
                    onClick={() => setSearchValue("")}
                  >
                    <RxCross1 />
                  </span>
                ) : null}
              </div>

              <ThemeButton
                onClick={() => {
                  toggleAddEdit();
                  setEditModal(false);
                  formik.resetForm();
                }}
              >
                {" "}
                Add New Partner
              </ThemeButton>
            </div>
          </PageHeading>

          <ReactTable
            headings={tableHeadings}
            data={partnerList || []}
            actionColumn
            statusColumn
            loading={
              partnerListLoading ||
              !partnerList ||
              bulkImportLoading ||
              propertyBulkImportLoading
            }
            actionButtonOptions={actionButtonOptions}
            currentPage={currentPage}
            itemPerPage={pageLimit}
            totalItems={totalRecords}
            setPerPageLimit={setPageLimit}
            setCurrentPage={setCurrentPage}
            pageLimit={pageLimit}
            pagination={true}
          />
          <input
            ref={orgUploadInputRef}
            type="file"
            accept=".csv,.xlsx,.xls,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            style={{ display: "none" }}
            onChange={handleOrganizationFileChange}
          />
          <input
            ref={propertyUploadInputRef}
            type="file"
            accept=".csv,.xlsx,.xls,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            style={{ display: "none" }}
            onChange={handlePropertyFileChange}
          />
          {
            excelData?.length > 0 && <ReactExcel
              setExcelData={setExcelData}
              // loading={excelDataLoading}
              // onClick={getExcelData}
              // buttonTitle="Export CSV"
              fileType="xlsx"
              fileName="Partner Property List"
              coulmns={excelHeaders}
              excelData={excelData}
            />
          }

          <ConfirmationModal
            handleToggle={toggleDelete}
            title="Are you sure you want to delete
                    this partner?"
            show={showDelete}
            confirm={() => deleteApi()}
            loading={deleteLoading}
          />

          <InactiveActiveModal
            loading={statusLoading}
            handleToggle={toggleActive}
            title={`Are you sure you want to ${selectedItem?.is_active ? "Deactivate" : "Activate"
              }
                  this partner?`}
            show={showActive}
            heading={selectedItem?.is_active ? "Deactivate" : "Activate"}
            confirm={() =>
              statusApi({
                is_active: selectedItem?.is_active ? 0 : 1,
              })
            }
          />

          <AddEditPartnersModal
            formik={formik}
            show={show}
            handleClose={toggleAddEdit}
            title={editModal ? "Edit Partner " : "Add Partner "}
            editModal={editModal}
            loading={addPartnerLoading || editPartnerLoading}
          />
        </div>

        {/* Referrer section*/}
        <div className={styles.dash_page}>
          <PageHeading
            heading="Referrer"
            subHeading="Here is the information about all your referrers."
          >
            <div className={styles.search}>
              <div className={styles.searchField}>
                <img
                  src={searchIcon}
                  className={styles.searchIcon}
                  alt="search icon"
                />

                <input
                  type="text"
                  placeholder="Search by Referrer"
                  className="me-3"
                  value={referrerSearchValue}
                  onChange={(e) => {
                    setReferrerCurrentPage(1);
                    setReferrerSearchValue(e.target.value);
                  }}
                  autoComplete="off"
                />
                {referrerSearchValue ? (
                  <span
                    className={styles.crossIcon}
                    onClick={() => setReferrerSearchValue("")}
                  >
                    <RxCross1 />
                  </span>
                ) : null}
              </div>

              <ThemeButton
                onClick={() => {
                  toggleReferrerAddEdit();
                  setReferrerEditModal(false);
                  referrerFormik.resetForm();
                }}
              >
                {" "}
                Add New Referrer
              </ThemeButton>
            </div>
          </PageHeading>

          <ReactTable
            headings={tableHeadings}
            data={referrerList || []}
            actionColumn
            statusColumn
            loading={referrerListLoading || !referrerList}
            actionButtonOptions={referrerActionButtonOptions}
            currentPage={referrerCurrentPage}
            itemPerPage={referrerPageLimit}
            totalItems={referrerTotalRecords}
            setPerPageLimit={setReferrerPageLimit}
            setCurrentPage={setReferrerCurrentPage}
            pageLimit={referrerPageLimit}
            pagination={true}
          />
          {
            referrerExcelData?.length > 0 && <ReactExcel
              setExcelData={setReferrerExcelData}
              // loading={excelDataLoading}
              // onClick={getExcelData}
              // buttonTitle="Export CSV"
              fileType="xlsx"
              fileName="Referrer Property List"
              coulmns={excelHeaders}
              excelData={referrerExcelData}
            />
          }

          <ConfirmationModal
            handleToggle={toggleReferrerDelete}
            title="Are you sure you want to delete
                    this referrer?"
            show={referrerDelete}
            confirm={() => deleteReferrerApi()}
            loading={deleteReferrerLoading}
          />

          <InactiveActiveModal
            loading={referrerStatusLoading}
            handleToggle={toggleReferrerActive}
            title={`Are you sure you want to ${selectedReferrerItem?.is_active ? "Deactivate" : "Activate"
              }
                  this referrer?`}
            show={referrerActive}
            heading={selectedReferrerItem?.is_active ? "Deactivate" : "Activate"}
            confirm={() =>
              referrerStatusApi({
                is_active: selectedReferrerItem?.is_active ? 0 : 1,
              })
            }
          />

          <AddEditPartnersModal
            formik={referrerFormik}
            show={referrerShow}
            handleClose={toggleReferrerAddEdit}
            title={referrerEditModal ? "Edit Referrer " : "Add Referrer "}
            editModal={referrerEditModal}
            loading={addReferrerLoading || editReferrerLoading}
            isReferrer={false}
          />
        </div>
      </Container>
    </DashboardLayout>
  );
};
export default Partners;
